// packages/web/src/lib/catalog/index.ts
// Public API exports for catalog module

export * from './branding';
export * from './cache';
export * from './detector';
export * from './preferences';
export * from './types';

// Legacy exports for backward compatibility
export { getCatalogBranding } from './branding';
export { clearAllCatalogCaches, clearUserCatalogCache } from './cache';
export { detectCatalogInstance } from './detector';
export { getUserActiveCatalogId } from './preferences';
